import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { SITE } from "@/constants/testIds";

const links = [
  { id: SITE.navLinkHome, label: "Home", href: "#hero" },
  { id: SITE.navLinkAbout, label: "About", href: "#about" },
  { id: SITE.navLinkLessons, label: "Lessons", href: "#lessons" },
  { id: SITE.navLinkTestimonials, label: "Testimonials", href: "#testimonials" },
  { id: SITE.navLinkContact, label: "Contact", href: "#contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid={SITE.navRoot}
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-brand-cream/85 backdrop-blur-md shadow-[0_6px_30px_-20px_rgba(35,66,53,0.35)]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 md:px-10 md:py-4">
        <a
          href="#hero"
          data-testid={SITE.navLogo}
          aria-label="The Spirit of Fishing — Home"
          className="h-10 w-10"
        />

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.id}
              data-testid={l.id}
              href={l.href}
              className={`text-sm font-medium transition-colors ${
                scrolled
                  ? "text-brand-evergreen/80 hover:text-brand-evergreen"
                  : "text-brand-cream/90 hover:text-brand-cream"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            data-testid={SITE.navCtaBook}
            href="#contact"
            className="rounded-full bg-brand-evergreen px-5 py-2 text-sm font-medium text-brand-cream transition-all duration-300 hover:bg-brand-sand hover:text-brand-evergreen"
          >
            Request a Session
          </a>
        </nav>

        <button
          type="button"
          data-testid={SITE.navMobileToggle}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
          className={`md:hidden ${
            scrolled ? "text-brand-evergreen" : "text-brand-cream"
          }`}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid={SITE.navMobileMenu}
          className="md:hidden border-t border-brand-evergreen/10 bg-brand-cream/95 backdrop-blur"
        >
          <div className="flex flex-col gap-1 px-6 py-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                onClick={close}
                className="rounded-lg px-3 py-3 text-base text-brand-evergreen/90 hover:bg-brand-sand/30"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={close}
              className="mt-2 rounded-full bg-brand-evergreen px-5 py-3 text-center text-sm font-medium text-brand-cream hover:bg-brand-sand hover:text-brand-evergreen"
            >
              Request a Session
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
